import React from "react";

export function ReviewIcon(props) {
  const { color = "#F9B341", ...otherProps } = props;
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27ZM12 15.4L8.24 17.67L9.24 13.39L5.91 10.61L10.3 10.13L12 6.1L13.7 10.13L18.09 10.61L14.76 13.39L15.76 17.67L12 15.4Z"
        fill={color}
      />
    </svg>
    
  );
}
